var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9649 11.4645C13.1414 9.28065 13.1414 5.72301 10.9649 3.53915L9.80387 4.70014V1.20223H13.3019L11.9505 2.55361C14.6832 5.28251 14.6832 9.72116 11.9505 12.4538C10.2257 14.1747 7.82527 14.8131 5.60028 14.3577V12.9167C7.45568 13.3983 9.51268 12.9167 10.9649 11.4645Z",
    fill: "#2581D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05 2.55361C3.77474 0.825183 6.17519 0.186823 8.40019 0.642261V2.08324C6.54478 1.60167 4.48405 2.0907 3.03557 3.53915C0.851639 5.72301 0.851639 9.28065 3.03557 11.4645L4.19659 10.3035V13.8052H0.694844L2.04627 12.4538C-0.68271 9.72116 -0.682711 5.28251 2.05 2.55361Z",
    fill: "#2581D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/TaskIcon.0a6d1f51d2cf588623bad6a183012612.svg";
export { ForwardRef as ReactComponent };